import { Component, OnInit, Output, EventEmitter, Input } from '@angular/core';
import { FormGroup } from '@angular/forms';
import { FormlyFieldConfig } from '@ngx-formly/core';
import { DataService } from 'src/app/services/data.service';
import * as CHART_PREFS from 'src/assets/json/ChartPrefrencesConfig.json';

@Component({
  selector: 'app-chart-preferences-formly',
  templateUrl: './chart-preferences-formly.component.html',
  styleUrls: ['./chart-preferences-formly.component.scss']
})
export class ChartPreferencesFormlyComponent implements OnInit {
  @Output() preferencesChange = new EventEmitter<any>();
  
  form = new FormGroup({});
  model: any = {};
  fields: FormlyFieldConfig[] = [];
  @Input('chartPrefConfig') chartPrefConfig:any;
  @Input('item') item:any;

  constructor(private dataService: DataService) { }
  // Dynamic configuration - can be loaded from API or config file
  private sectionsConfig: any[] = [];

  ngOnInit(): void {
    const allConfigs = (CHART_PREFS as any).default;
    if (allConfigs && allConfigs[this.item.key]) {
      this.sectionsConfig = allConfigs[this.item.key];
    } else {
      console.error(`Configuration for key '${this.item.key}' not found / or json is not avaliable`);
      this.sectionsConfig = []; // Set to a safe default
    }

    this.generateFormlyFields();
    this.initializeModel();
    
    // Watch for form changes
    this.form.valueChanges.subscribe(value => {
      // console.log(value);
      
      this.preferencesChange.emit(value);
    });
  }

  generateFormlyFields(): void {
    this.fields = this.sectionsConfig.map(section => ({
      key: section.key,
      wrappers: ['panel'],
      props: {
        label: section.label,
        icon: section.icon,
        expanded: section.expanded
      },
      fieldGroup: this.generateFieldGroup(section.fields, section.key)
    }));
    
    
  }

  generateFieldGroup(fields: any[], parentKey: string): FormlyFieldConfig[] {
    return fields.map(field => {
      const config: FormlyFieldConfig = {
        key: field.key,
        type: this.mapFieldType(field.type),
         className: 'formly-field',
        props: {
          label: field.label,
          required: field.required || false
        }
      };

      // Add conditional display
      if (field.hideExpression) {
        config.hideExpression = field.hideExpression;
      }

      // Type-specific configurations
      switch (field.type) {
        case 'slider':
          config.props = {
            ...config.props,
            min: field.min || 0,
            max: field.max || 100,
            thumbLabel: true
          };
          break;
        
        case 'number':
          config.props = {
            ...config.props,
            min: field.min,
            max: field.max,
            type: 'number'
          };
          break;
        
        case 'select':
          config.props = {
            ...config.props,
            options: field.options.map((opt: string) => ({ label: opt, value: opt }))
          };
          break;
        
        case 'radio':
          config.props = {
            ...config.props,
            options: field.options.map((opt: string) => ({ label: opt, value: opt }))
          };
          break;
        
        case 'color':
          config.props = {
            ...config.props,
            type: 'color'
          };
          break;
      }

      return config;
    });
  }

  mapFieldType(type: string): string {
    const typeMap: { [key: string]: string } = {
      'toggle': 'toggle',
      'slider': 'slider',
      'number': 'input',
      'select': 'select',
      'radio': 'radio',
      'color': 'color-picker',
      'text': 'input'
    };
    return typeMap[type] || 'input';
  }

  initializeModel(): void {
    this.sectionsConfig.forEach(section => {
      this.model[section.key] = {};
      section.fields.forEach((field:any) => {
        this.model[section.key][field.key] = field.defaultValue;
      });
    });
    this.getPreferences();
  }

  resetToDefaults(): void {
    this.initializeModel();
    this.form.reset(this.model);
  }

  exportPreferences(): void {
    const dataStr = JSON.stringify(this.model, null, 2);
    const dataBlob = new Blob([dataStr], { type: 'application/json' });
    const url = URL.createObjectURL(dataBlob);
    const link = document.createElement('a');
    link.href = url;
    link.download = 'chart-preferences.json';
    link.click();
    URL.revokeObjectURL(url);
  }

  importPreferences(event: any): void {
    const file = event.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onload = (e: any) => {
        try {
          const preferences = JSON.parse(e.target.result);
          this.model = preferences;
          this.form.patchValue(preferences);
        } catch (error) {
          console.error('Invalid preferences file:', error);
        }
      };
      reader.readAsText(file);
    }
  }

  // Method to dynamically add a new section
  addSection(sectionConfig: any): void {
    this.sectionsConfig.push(sectionConfig);
    this.generateFormlyFields();
    this.initializeModel();
  }

  // Method to dynamically add a field to existing section
  addFieldToSection(sectionKey: string, fieldConfig: any): void {
    const section = this.sectionsConfig.find(s => s.key === sectionKey);
    if (section) {
      section.fields.push(fieldConfig);
      this.generateFormlyFields();
      if (fieldConfig.defaultValue !== undefined) {
        this.model[sectionKey][fieldConfig.key] = fieldConfig.defaultValue;
      }
    }
  }

  // Method to remove a field
  removeField(sectionKey: string, fieldKey: string): void {
    const section = this.sectionsConfig.find(s => s.key === sectionKey);
    if (section) {
      section.fields = section.fields.filter((f:any) => f.key !== fieldKey);
      this.generateFormlyFields();
      delete this.model[sectionKey][fieldKey];
    }
  }

  // Load configuration from external source (API, JSON file, etc.)
  loadConfiguration(config: any[]): void {
    this.sectionsConfig = config;
    this.generateFormlyFields();
    this.initializeModel();
  }

  onSubmit() {
    // console.log("Form Submitted:", this.model);
  // if (this.form.valid) {
  //   this.preferencesChange.emit(this.model);
  //   console.log("Preferences Applied:", this.model);
  // }
}

onCancel() {
  // revert to original values or just close this panel (depends your use case)
  this.form.reset(this.model);
  console.log("Preferences Cancelled");
}
getPreferences() {
    if(this.chartPrefConfig?.widget_uinique_key) {
      let obj = {
        dashboard_key: this.chartPrefConfig.dashboard_key,
        page_name: this.chartPrefConfig.page_name,
        page_key: this.chartPrefConfig.page_key,
        widget_uinique_key: this.chartPrefConfig.widget_uinique_key,
        employee_key: this.chartPrefConfig.employee_key
      }
      this.dataService.getPreference(obj).subscribe((res:any) => {
        if(res && res.length) {
          let value = res?.[0]?.preference_value ? JSON.parse(res?.[0]?.preference_value) : '';
          if(!value) return;
          console.log("Fetched Preferences:", value);
          this.model =  Object.keys(value).length ? value : this.model;
          this.form.patchValue(this.model);
        }
        const key = this.chartPrefConfig?.widget_uinique_key;
        if (!localStorage.getItem("pref_backup_" + key)) {
        localStorage.setItem("pref_backup_" + key, JSON.stringify(this.model));
      }
      })
    }
  }

}